/* ============================================================
   KCC Feedback JS - Level 2 dynamic states
   ============================================================
   Lightweight vanilla JavaScript. No dependencies.
   Loaded with defer in theme.liquid so it doesn't block render.

   Handles:
     1. Form submit loading state (.is-loading class)
     2. Image lazy-load fade-in (opacity transition on load)
     3. Internal link page transitions (.kcc-page-leaving)
     4. Cart action success pulse hook (called by other code)

   All behaviour gated by prefers-reduced-motion check.
   ============================================================ */

(function () {
  'use strict';

  var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ============================================================
     1. FORM SUBMIT LOADING STATE
     ============================================================
     Adds .is-loading to submit buttons when their form submits.
     Prevents double-submission. CSS handles the visual.
     ============================================================ */

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || form.tagName !== 'FORM') return;

    // Skip if form has data-kcc-no-loading attribute (opt-out)
    if (form.hasAttribute('data-kcc-no-loading')) return;

    // Find the submit button inside the form
    var submitBtn = form.querySelector('button[type="submit"], input[type="submit"], button:not([type])');
    if (!submitBtn) return;

    // Skip if button is already loading
    if (submitBtn.classList.contains('is-loading')) {
      e.preventDefault();
      return;
    }

    // Add loading state
    submitBtn.classList.add('is-loading');
    submitBtn.setAttribute('aria-busy', 'true');

    // Failsafe: remove loading state after 30s in case form fails silently
    setTimeout(function () {
      submitBtn.classList.remove('is-loading');
      submitBtn.removeAttribute('aria-busy');
    }, 30000);
  }, true);

  /* ============================================================
     2. IMAGE LAZY-LOAD FADE-IN
     ============================================================
     Adds .kcc-image-loaded once a lazy image finishes loading.
     CSS transitions opacity from 0 to 1.
     ============================================================ */

  function markImageLoaded(img) {
    if (img.complete && img.naturalHeight !== 0) {
      img.classList.add('kcc-image-loaded');
    } else {
      img.addEventListener('load', function () {
        img.classList.add('kcc-image-loaded');
      }, { once: true });

      img.addEventListener('error', function () {
        // On error, still mark as loaded so it shows the broken icon
        img.classList.add('kcc-image-loaded');
      }, { once: true });
    }
  }

  function processLazyImages() {
    var lazyImages = document.querySelectorAll('img[loading="lazy"], img.kcc-lazy');
    for (var i = 0; i < lazyImages.length; i++) {
      markImageLoaded(lazyImages[i]);
    }
  }

  // Initial pass + watch for new images injected dynamically
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', processLazyImages);
  } else {
    processLazyImages();
  }

  // Watch for dynamically added images (e.g. quickview, AJAX product loads)
  if ('MutationObserver' in window) {
    var observer = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var nodes = mutations[i].addedNodes;
        for (var j = 0; j < nodes.length; j++) {
          var node = nodes[j];
          if (node.nodeType !== 1) continue;
          if (node.tagName === 'IMG') {
            markImageLoaded(node);
          } else if (node.querySelectorAll) {
            var imgs = node.querySelectorAll('img[loading="lazy"], img.kcc-lazy');
            for (var k = 0; k < imgs.length; k++) {
              markImageLoaded(imgs[k]);
            }
          }
        }
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  /* ============================================================
     3. PAGE TRANSITION FADE (REMOVED)
     ============================================================
     The page transition fade was removed because it caused click
     timing issues with theme nav dropdowns on some user sessions.
     The other Level 2 features (form loading, image fade-in,
     success pulse) remain active.
     ============================================================ */

  /* ============================================================
     4. PUBLIC API: KCC.successPulse(element)
     ============================================================
     Other code (e.g. cart drawer JS, custom AJAX add-to-cart)
     can trigger the green success pulse on any element.
     Example: window.KCC.successPulse(document.querySelector('.cart-icon'));
     ============================================================ */

  window.KCC = window.KCC || {};

  window.KCC.successPulse = function (el) {
    if (!el || !el.classList) return;
    el.classList.remove('kcc-success-pulse');
    // Force reflow so animation can restart
    void el.offsetWidth;
    el.classList.add('kcc-success-pulse');
    setTimeout(function () {
      el.classList.remove('kcc-success-pulse');
    }, 1300);
  };

  window.KCC.cartLineUpdated = function (el) {
    if (!el || !el.classList) return;
    el.classList.remove('kcc-cart-updated');
    void el.offsetWidth;
    el.classList.add('kcc-cart-updated');
    setTimeout(function () {
      el.classList.remove('kcc-cart-updated');
    }, 700);
  };

  /* ============================================================
     5. LISTEN FOR SHOPIFY CART EVENTS
     ============================================================
     Modern Shopify themes fire 'cart:updated' or similar custom
     events. We hook in and trigger the success pulse on the
     cart icon if present.
     ============================================================ */

  function findCartIcon() {
    return document.querySelector(
      '[data-cart-count], [data-cart-icon], .cart-link, .header__cart, .js-cart-icon, .site-header__cart'
    );
  }

  ['cart:updated', 'cart:add', 'cart-drawer:add', 'shopify:cart:update'].forEach(function (eventName) {
    document.addEventListener(eventName, function () {
      var icon = findCartIcon();
      if (icon) window.KCC.successPulse(icon);
    });
  });

})();